import {MAIN_LOGO} from "./theme-variables";

export const themeLocations = Object.freeze({
    /* Main app logo */
    MAIN_LOGO,
});